/**
 * @documentation https://github.com/mapbox/polyline
 *
 * @param str
 * @param precision
 * @return {*[]}
 */
window.decodePolyline = (str, precision) => {
    let index = 0,
        lat = 0,
        lng = 0,
        coordinates = [],
        shift = 0,
        result = 0,
        byte = null,
        latitude_change,
        longitude_change,
        factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);

    // Coordinates have variable length when encoded, so just keep
    // track of whether we've hit the end of the string. In each
    // loop iteration, a single coordinate is decoded.
    while (index < str.length) {
        // Reset shift, result, and byte
        byte = null;
        shift = 1;
        result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result += (byte & 0x1f) * shift;
            shift *= 32;
        } while (byte >= 0x20);

        latitude_change = (result & 1) ? ((-result - 1) / 2) : (result / 2);

        shift = 1;
        result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result += (byte & 0x1f) * shift;
            shift *= 32;
        } while (byte >= 0x20);

        longitude_change = (result & 1) ? ((-result - 1) / 2) : (result / 2);

        lat += latitude_change;
        lng += longitude_change;
        coordinates.push([lat / factor, lng / factor]);
    }

    return coordinates;
}

/**
 * @documentation https://github.com/mapbox/mapbox-gl-directions/tree/main
 *
 * @param feature
 * @param filterBy
 * @return {*}
 */
window.getAllSteps = (feature, filterBy) => {
    return feature.legs.reduce((steps, leg, idx) => {
        if (idx > 0) {
            steps[steps.length - 1].maneuver.type = 'waypoint';
            leg.steps[0].maneuver.type = '';
        }

        const allSteps = steps.concat(leg.steps);

        if (filterBy) {
            return allSteps.filter(filterBy);
        } else {
            return allSteps;
        }
    }, []);
}

window.directionSegmentation = (feature, decoded, index) => {
    const features = [];
    decoded.forEach(function (c, i) {
        const previous = features[features.length - 1];
        const congestion = feature.legs[0].annotation &&
            feature.legs[0].annotation.congestion &&
            feature.legs[0].annotation.congestion[i - 1];

        if (previous && (!congestion || previous.properties.congestion === congestion)) {
            previous.geometry.coordinates.push(c);
        } else {
            const segment = {
                geometry: {
                    type: 'LineString',
                    coordinates: []
                },
                properties: {
                    'route-index': index,
                    route: 'selected',
                }
            };

            // New segment starts with previous segment's last coordinate.
            if (previous) {
                segment.geometry.coordinates.push(
                    previous.geometry.coordinates[previous.geometry.coordinates.length - 1]
                );
            }

            segment.geometry.coordinates.push(c);

            if (congestion) {
                segment.properties.congestion = feature.legs[0].annotation.congestion[i - 1];
            }

            features.push(segment);
        }
    });

    return features;
}

window.slugify = (text) => {
    return text
        .toString()                   // Cast to string (optional)
        .normalize('NFKD')            // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
        .toLowerCase()                // Convert the string to lowercase letters
        .trim()                       // Remove whitespace from both sides of a string (optional)
        .replace(/\s+/g, '-')         // Replace spaces with -
        .replace(/[^\w\-]+/g, '')     // Remove all non-word chars
        .replace(/\_/g,'-')           // Replace _ with -
        .replace(/\-\-+/g, '-')       // Replace multiple - with single -
        .replace(/\-$/g, '');         // Remove trailing -
}

window.secondsToDhms = (seconds) => {
    seconds = Number(seconds);
    const d = Math.floor(seconds / (3600*24));
    const h = Math.floor(seconds % (3600*24) / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = Math.floor(seconds % 60);

    return {d, h, m, s}
}

window.displayTimeDurationInDays = (seconds) => {
    const convert = window.secondsToDhms(seconds)
    let s = '';

    if (convert.d > 0) {
       s = convert.d + 'j ' ;
    }

    if (convert.h > 0) {
        s = s + convert.h + 'h ';
    }

    if (convert.m > 0) {
        s = s + convert.m + 'min ';
    }

    return s;
}

window.poi_category_translation = (category) => {
    const translation = {
        'city': 'Ville',
        'state': 'État',
        'park': 'Parc',
        'see': 'À voir',
        'sleep' : 'Dormir',
        'food' : 'Manger',
        'walk' : 'Activité',
        'drink' : 'Boire',
        'music' : 'Musique',
        'cinema' : 'Cinéma',
        'nature' : 'Nature',
        'animals' : 'Animaux',
        'shop' : 'Shopping',
        'drive' : 'Route',
        'weird' : 'Insolite'
    }

    return Array.isArray(category)
        ? category.map(cat => translation[cat]).join(', ')
        : translation[category];
}